import { render, staticRenderFns } from "./SimpleStat.vue?vue&type=template&id=270810e5&scoped=true"
import script from "./SimpleStat.vue?vue&type=script&lang=js"
export * from "./SimpleStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270810e5",
  null
  
)

export default component.exports